module.exports = __webpack_public_path__ + "static/dl2-stay-human_screen4-770e9a98f2305c81b78ebda31816a523.png";